import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DataListTemplates, DataTypes } from '../../../../common/constants';
import { setButtonsText } from '../../../../store/banner/bannerSlice';
import { RenderIcons } from '../../../controls/icons';
import DataListing from '../../../listing/listing';
import { getConfiguredLabel } from '../../../../common/commonHelper';
import { addButton, addDocPopUp, cancelButton, deleteButton, deleteMessage, documents, DocumentsPage, editDocPopUp, editToaster, editToasterMessage, HeaderMenu, mydocbanner, saveButton } from '../../../../common/labelConstants';
import { usePermissions } from '../../../../hooks/usePermissions';
import { UploadButton } from '../../uploadButton';
import { DocumentAnalyticsInfo } from '../analytics/docAnalyticsInfo';

const _props = {
  handleDownloadFile: (selectedRows) => { },
  handleDeleteDoc: (rows, refresh, showDeletePopup) => { }
}
function MyDocuments(props = _props) {
  const dispatch = useDispatch()
  const permissions = usePermissions();
  const slbSearchConfig = window.slbConfig;

  const actionToaster = {
    edit: { title: getConfiguredLabel(DocumentsPage, editToaster), message: getConfiguredLabel(DocumentsPage, editToasterMessage) }
  }
  const chartConfig = useSelector((x)=>x.chart.chartConfig);
  
  if(chartConfig && chartConfig.widgets)
  {
    var chartConfigObject=chartConfig.widgets.find(x => x.moduleName === DataListTemplates.myDocuments);
  }

  return (<div>
    {/* <DocumentAnalyticsInfo dataListTemplate={DataListTemplates.myDocuments} /> */}
    {chartConfigObject ?  <DocumentAnalyticsInfo
        dataListTemplate={DataListTemplates.myDocuments}
        chartConfig={chartConfigObject}
      />:<></>}
    <DataListing
      paginator={true}
      handleDelete={(rows, refreshData_fn, showDeletePopup) => props.handleDeleteDoc(rows, refreshData_fn, showDeletePopup)}
      handleDownload={props.handleDownloadFile}
      dataType_id={DataTypes.Documents.id}
      templateName={DataListTemplates.myDocuments}
      actionToaster={actionToaster}
      renderHeaderAreaLeft={({ pagingInfo }) => {
        return <>
          {pagingInfo}
        </>
      }}
      pageActionsInfo={{
        add: { title: getConfiguredLabel(DocumentsPage, addDocPopUp), message: '', actions: { ok: { label: getConfiguredLabel(DocumentsPage, addButton) }, cancel: { label: getConfiguredLabel(DocumentsPage, cancelButton) } } },
        edit: { title: getConfiguredLabel(DocumentsPage, editDocPopUp), message: '', actions: { ok: { label: getConfiguredLabel(DocumentsPage, saveButton) }, cancel: { label: getConfiguredLabel(DocumentsPage, cancelButton) } } },
        delete: { title: getConfiguredLabel(DocumentsPage, deleteButton), message: getConfiguredLabel(DocumentsPage, deleteMessage), actions: { ok: { label: getConfiguredLabel(DocumentsPage, deleteButton) }, cancel: { label: getConfiguredLabel(DocumentsPage, cancelButton) } } },

      }}
      renderHeaderAreaRight={({ btn_delete, btn_download, filter_global, orderBy_icon, sortBy_dropdown, selectedRows, setSelectedRows }) => {
        return <>
          {filter_global}
          <span className='download_icon' onClick={() => {
            props.handleDownloadFile(selectedRows, setSelectedRows)
          }}>{RenderIcons("download")}</span>
          <span>{btn_delete}</span>
          {sortBy_dropdown}
        </>
      }}
    />
  </div>)

}
export default MyDocuments;